import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { useConfig } from '../../../../../context';
import { CdnIcon } from '@shared/ui';
import Link from '../../../../../Link/Link';
const AdditionalLinks = () => {
    const { SearchForm: { additionalLinks = [] } } = useConfig();
    const { AdditionalLinks: css } = useTheme('SearchForm');
    const { t } = useTranslation('SearchForm');
    if (!additionalLinks || additionalLinks.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: css.container }, additionalLinks.map((link, index) => (React.createElement(Link, Object.assign({ key: index, action: link.url, className: cn(css.link, link.className), target: link.openInNewTab ? '_blank' : undefined }, (link.openInNewTab ? { rel: 'noopener noreferrer' } : {})),
        link.icon && React.createElement(CdnIcon, { icon: link.icon, className: css.icon }),
        React.createElement("span", { className: css.title }, t(link.title)))))));
};
export default AdditionalLinks;
